import { ORDER } from '@arpeggi/shared'
import { useState } from 'react'
import { useUsers } from '../../../queries/users'

type OrderByType = 'createdAt' | 'displayName'

export const useUserDashboard = () => {
  const [params, setParams] = useState<{ orderBy: OrderByType; order: ORDER }>({
    orderBy: 'createdAt',
    order: 'desc'
  })
  const [totalUsers, setTotalUsers] = useState<number | undefined>(undefined)

  const userQuery = useUsers(
    {
      orderBy: params.orderBy,
      order: params.order
    },
    {
      onSuccess: (data) => {
        if (!totalUsers) {
          setTotalUsers(data.pages[0].meta.total)
        }
      }
    }
  )

  const handleOrderBy = (value: OrderByType) => {
    let order: ORDER
    if (value !== params.orderBy) {
      order = 'desc'
    } else {
      order = params.order === 'desc' ? 'asc' : 'desc'
    }

    setParams({ order, orderBy: value })
  }

  return {
    ...params,
    ...userQuery,
    handleOrderBy,
    totalUsers
  }
}
